<section class="platform" id="about">
  <h2>One Platform. Endless Possibilities.</h2>
  <p class="platform-subtitle">
    From ordering and deliveries to store management and ERP, OrderYaa provides all the tools you
    need in one powerful platform. Whether you're a customer looking for your favourite local store,
    a rider ready to earn on your own schedule, or a business owner ready to grow, OrderYaa brings
    everyone together in one place, backed by a powerful ERP and POS system that keeps every order,
    delivery, and sale running smoothly.
  </p>

  <div class="platform-grid">
    <a class="platform-card" [href]="customerUrl" target="_blank" rel="noopener">
      <img src="/images/order1.png" alt="Place your order" />
      <span class="platform-label">Place your order</span>
    </a>
    <a class="platform-card" [href]="riderUrl" target="_blank" rel="noopener">
      <img class="platform-img-top" src="/images/rider-clean.png" alt="Become a rider" />
      <span class="platform-label">Become a rider</span>
    </a>
    <a
      class="platform-card"
      [href]="partnerUrl"
      target="_blank"
      rel="noopener"
    >
      <img class="platform-img-left" src="/images/store-clean.png" alt="Create your store" />
      <span class="platform-label">Create your store</span>
    </a>
    <a
      class="platform-card"
      [href]="erpAppUrl"
      target="_blank"
      rel="noopener"
    >
      <img src="/images/erp.png" alt="Orderyaa ERP" />
      <span class="platform-label">Orderyaa ERP</span>
    </a>
  </div>
</section>
